import React, { useMemo } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { Paper } from '@mui/material';
import {
  ChatHistoryUserSummary,
  AdminChatHistoryService,
} from 'us-web-services';
import { Table, TableInstance } from 'src/components/common/Table';
import PageStyles from '../../styles/PageStyles';
import DateUtil from '../../util/DateUtil';

function ChatHistoryLookup(props: RouteComponentProps) {
  const { history } = props;
  const tableRef = React.useRef<TableInstance>();
  const { classes } = PageStyles();

  const COLUMNS = useMemo(
    () => [
      {
        id: 'chatHistory',
        header: 'Chat History',
        columns: [
          {
            accessorKey: 'userId',
            header: 'User ID',
            enableEditing: false,
            size: 100,
          },
          {
            accessorKey: 'messageCount',
            header: 'Message Count',
            enableEditing: false,
            size: 140,
          },
          {
            header: 'Last Message At',
            accessorFn: row =>
              row?.lastMessageAt ? DateUtil.getReadableDateTime(row.lastMessageAt) : '',
            enableEditing: false,
            size: 180,
          },
        ],
      },
    ],
    [],
  );

  const viewConversation = (rowData: ChatHistoryUserSummary) => {
    history.push(`/chat-history/${rowData.userId}`);
  };

  const retrieveData = async (config: any) => {
    return AdminChatHistoryService.getUserSummaries(config);
  };

  return (
    <Paper className={classes.paper}>
      <Table
        ref={tableRef}
        columns={COLUMNS}
        retrieveData={retrieveData}
        onRowClick={viewConversation}
      />
    </Paper>
  );
}

export default withRouter(ChatHistoryLookup);
